import React__default, { useMemo, useEffect } from 'react';
import { loadSwanPolyfill } from '../../../core/utilities/load-polyfill.js';
import { createSwanVersionMetaTag, createSwanGlobalObject } from '../../../core/utilities/swan-version.js';
import { ExperimentsProvider } from '../experiments/experiments.context.js';
import { swanLoaderConfigProps, SwanContext } from './swan-provider.context.js';
import { SwanPathTypeEnum } from '../../../core/types/enums.js';
import { getSwanBaseUrl } from '../../../core/utilities/base-url.utils.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
createSwanVersionMetaTag();
const propTypes = _object_spread_props(_object_spread({}, swanLoaderConfigProps), {
    pathType: swanLoaderConfigProps.swanPathType
});
const DEFAULT_SWAN_PATH_TYPE_ENUM = SwanPathTypeEnum.hashed;
const SwanProvider = ({ swanBaseUrl , pathType , swanPathType , swanTenant , swanLocale , globalLinkComponent , experiments , children  })=>{
    const baseUrl = swanBaseUrl || getSwanBaseUrl(swanTenant, swanLocale);
    const path = swanPathType || pathType || DEFAULT_SWAN_PATH_TYPE_ENUM;
    const value = useMemo(()=>{
        return {
            globalLinkComponent,
            swanBaseUrl: baseUrl,
            swanPathType: path,
            swanTenant,
            swanLocale
        };
    }, [
        globalLinkComponent,
        baseUrl,
        path,
        swanTenant,
        swanLocale
    ]);
    useEffect(()=>{
        createSwanGlobalObject(value.swanBaseUrl);
    }, [
        value.swanBaseUrl
    ]);
    useEffect(()=>{
        // add polyfill url in the head
        loadSwanPolyfill(baseUrl);
    }, [
        baseUrl
    ]);
    return /*#__PURE__*/ React__default.createElement(SwanContext.Provider, {
        value: value
    }, /*#__PURE__*/ React__default.createElement(ExperimentsProvider, {
        experiments: experiments
    }, children));
};
SwanProvider.displayName = 'SwanProvider';
SwanProvider.propTypes = propTypes;

export { SwanProvider };
